<!--
 * @Author: yinwenxuan yinwenxuan@vip56.cn
 * @Date: 2023-03-22 09:04:29
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2026-01-04 13:44:55
 * @FilePath: \PosManager-Front\src\views\h5\h5Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="ad_main">
      <div class="am_line">
        <span class="label">门店编号：</span>
        <span class="val">{{form.shopNo}}</span>
      </div>
      <div class="am_line">
        <span class="label">门店名称：</span>
        <span class="val">{{form.shopName}}</span>
      </div>
      <div class="am_line">
        <span class="label">门店类型：</span>
        <span class="val">{{form.type}}</span>
      </div>
      <div class="am_line">
        <span class="label">订单编号：</span>
        <span class="val">{{form.orderNo}}</span>
      </div>
      <div class="am_line">
        <span class="label">下单选择的支付方式：</span>
        <span class="val">{{getPayStatus}}</span>
      </div>
      <div class="am_line">
        <span class="label">实际扫码的支付方式：</span>
        <span class="val">{{getPayStatus2}}</span>
      </div>
      <div class="am_line">
        <span class="label">订单金额：</span>
        <span class="val">{{form.amount}}</span>
      </div>
      <div class="am_line">
        <span class="label">付款码：</span>
        <span class="val">{{form.authCode}}</span>
      </div>
      <div class="am_line">
        <span class="label">信息：</span>
        <span class="val">{{form.msg}}</span>
      </div>
      <div class="am_line">
        <span class="label">接口版本：</span>
        <span class="val">{{form.apiVersion}}</span>
      </div>
      <div class="am_line">
        <span class="label">创建时间：</span>
        <span class="val">{{form.createTime}}</span>
      </div>
    </div>
</template>

<script>
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
import dayjs from "dayjs";
import { Operations } from '@/http/api_Operations';
export default{
    components:{
    },
    data(){
        return{
           form:{

           },
            payOptions: [
            {
            label: "/",
            value: 0,
            },
            {
            label: "会员卡支付",
            value: 1,
            },
            {
            label: "现金支付",
            value: 2,
            },
            {
            label: "微信支付",
            value: 3,
            },
            {
            label: "支付宝支付",
            value: 4,
            },
            {
            label: "现金+会员卡+微信",
            value: 5,
            },
            {
            label: "现金+会员卡+支付宝",
            value: 6,
            },
            {
            label: "现金+微信",
            value: 7,
            },
            {
            label: "现金+支付宝",
            value: 8,
            },
            {
            label: "会员卡+微信",
            value: 9,
            },
            {
            label: "会员卡+支付宝",
            value: 10,
            },
            {
            label: "现金+会员卡",
            value: 11,
            },
            {
            label: "线下微信",
            value: 13,
            },
            {
            label: "线下支付宝",
            value: 14,
            },
            {
            label: "现金+线下支付宝",
            value: 15,
            },
            {
            label: "会员卡+线下支付宝",
            value: 16,
            },
            {
            label: "现金+线下微信",
            value: 17,
            },
            {
            label: "会员卡+线下微信",
            value: 18,
            },
            {
            label: "线下微信+线下支付宝",
            value: 19,
            },
            {
            label: "现金+会员卡+线下支付宝",
            value: 20,
            },
            {
            label: "现金+会员卡+线下微信",
            value: 21,
            },
            {
            label: "现金+线下支付宝+线下微信",
            value: 22,
            },
            {
            label: "会员卡+线下支付宝+线下微信",
            value: 23,
            },
        ],
       
        shopTypeOptions:[
            {
              label: "全部门店类型",
              value: '',
            },
            {
              label: "聚合",
              value: '1',
            },
            {
              label: "直连",
              value: '2',
            }
        ],
        }
    },
    async mounted() {
        
    },
    async created() {
        this.form = localStorage.getItem("abnormalDetail")?JSON.parse(localStorage.getItem("abnormalDetail")):{};
    },
    computed:{
        getPayStatus() {
            let str = "";
            str = this.payOptions.find((v) => v.value == this.form.paymentMethod).label;
            return str;
        },
        getPayStatus2() {
            let str = "";
            str = this.payOptions.find((v) => v.value == this.form.nowPaymentMethod).label;
            return str;
        },
        shopType(){
          let str = "";
          str = this.payOptions.find((v) => v.value == this.payType).label;
          return str;
        }
    },
    methods:{
    
    }
    
}
</script>

<style lang="scss" scoped>
@function px2vw($n) {
    @return ($n / 374 * 100) * 1vw;
}
div{
    box-sizing: border-box;
}
.ad_main{
  font-size: px2vw(14);
  padding-top: px2vw(20);
  .am_line{
    margin-bottom: px2vw(15);
    padding: 0 px2vw(10);
  }
}
@media screen and (min-width:1024px) {
  .ad_main{
    padding-top: 20px;
    font-size: 14px;
    .am_line{
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/internalH5/abnormalDetail.vue